/**
 * Builds the user-search query a privileged client (superadmin/support masquerade) sends to
 * scope a dropdown to the current company. Every call site that skips this and hand-rolls the
 * query string risks re-introducing #21857/ENG-1004 (cross-company users leaking into
 * estimator/owner dropdowns) — extracted so there's exactly one place to get it right.
 *
 * Defaults to active-only, matching the server's own default scoping for non-privileged
 * sessions (see `includeInactive` on the `searchUsers` GraphQL query). Pass `includeInactive:
 * true` for a dropdown that must resolve historical/deactivated users too (e.g. an estimator
 * report filter, where past data can reference someone no longer on the team) — callers doing so
 * must also pass `includeInactive: true` in their own `useSearchUsersQuery` variables, since the
 * server applies that same default independently for non-privileged sessions.
 *
 * Non-privileged sessions send `''` and rely on the server's own default scoping.
 */
export function buildScopedUserQuery({
  isPrivileged,
  clientId,
  includeInactive = false
}: {
  isPrivileged: boolean
  clientId: string
  includeInactive?: boolean
}): string {
  if (!isPrivileged) return ''
  return `app_metadata.companyId:"${clientId}"${includeInactive ? '' : ' AND app_metadata.active:true'}`
}
